import { getClassNames } from '@websolutespa/bom-core';
import { CanvasOffscreenProvider, useLlm } from '@websolutespa/bom-mixer-llm';
import { forwardRef } from 'react';
import '../../scss/style.scss';
import style from './page-root.module.scss';

export type PageRootProps = {
  mode: string;
  opened?: boolean;
  embedded?: boolean;
  customIntro?: boolean;
};

export const PageRoot = forwardRef<HTMLDivElement, PageRootProps>(
  function PageRoot({
    opened,
    embedded,
    customIntro,
    mode,
  }, ref) {
    const { Font, PageMain } = useLlm(state => state.components);

    const classNames = getClassNames('llm', style.root, {
      '-open': opened,
      '-embedded': embedded,
      '-custom-intro': customIntro,
      [style['-' + mode]]: true,
    });

    return (
      <section ref={ref} className={classNames}>
        <CanvasOffscreenProvider>
          <Font />
          <PageMain key="main" />
        </CanvasOffscreenProvider>
      </section>
    );
  }
);
